import { ErrorOutline } from '@mui/icons-material'
import { Stack, Typography, useTheme } from '@mui/material'
import React from 'react'

interface ErrorDisplayProps {
  message?: string
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ message }) => {
  const theme = useTheme()
  if (!message) return null
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        padding: theme.spacing(2, 2),
        marginTop: '10px',
        borderRadius: theme.shape.borderRadius + 'px',
      }}
      spacing={1}
    >
      <ErrorOutline fontSize="small" sx={{ color: theme.palette.error.contrastText }} />
      <Typography variant="caption">{message}</Typography>
    </Stack>
  )
}

export default ErrorDisplay
